module.exports = __webpack_public_path__ + "img/accf40c9c1f93642fba8503910a7d8a1.png";